import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Button, Typography } from '@material-ui/core';
import FormTextField from '../form/FormTextField';
import { userProfileValidation } from '../../models/auth/AuthModelValidation';
import ParticipantAddress from '../auth/registration/ParticipantAddress';
import { ParticipantTypes } from '../../models/auth/ParticipantTypes';
import FormRadioGroup from '../form/FormRadioGroup';
import { ParticipantOrganizationTypes } from '../../models/auth/ParticipantOrganizationTypes';
import FormSelect from '../form/FormSelect';

const UserProfileForm = ({ t, onSubmit, initialValues }) => {
  const organizationTypes = [
    { value: ParticipantOrganizationTypes.nonGovernment, name: t(`auth.participantAccounts.participantOrganizationType.${ParticipantOrganizationTypes.nonGovernment}`) },
    { value: ParticipantOrganizationTypes.subordinate, name: t(`auth.participantAccounts.participantOrganizationType.${ParticipantOrganizationTypes.subordinate}`) },
    { value: ParticipantOrganizationTypes.company, name: t(`auth.participantAccounts.participantOrganizationType.${ParticipantOrganizationTypes.company}`) },
  ];
  
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={userProfileValidation}
      render={({ handleSubmit, submitting, values }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <Field
              name="firstName"
              component={FormTextField}
              label="Imię"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="lastName"
              component={FormTextField}
              label="Nazwisko"
              fullWidth
            />
          </div>
          <Typography variant="overline" component="div">Dane dodatkowe</Typography>
          {!values.participantType ? <Typography variant="caption" component="div" gutterBottom>Wprowadzenie informacji umożliwi weryfikację i potwierdzenie Twojej tożsamości</Typography> : null}
          <div>
            <Field
              name="participantType"
              component={FormRadioGroup}
              values={[
                { value: '', name: 'Bez dodatkowych danych', subtitle: 'Konto nie podlega weryfikacji i umożliwia udział wyłącznie w konsultacjach otwartych' },
                { value: ParticipantTypes.naturalPerson, name: 'Osoba fizyczna', subtitle: 'Konto podlega weryfikacji i umożliwia udział w konsultacjach otwartych oraz dostępnych tylko dla osób zweryfikowanych' },
                { value: ParticipantTypes.legalEntity, name: 'Instytucja lub podmiot publiczny', subtitle: 'Konto podlega weryfikacji i umożliwia udział w konsultacjach otwartych oraz dostępnych wyłącznie dla osób zweryfikowanych, dla firm, dla jednostek podległych i organizacji pozarządowych' }
              ]}
            />
          </div>
          {values.participantType === ParticipantTypes.naturalPerson
            ? <React.Fragment>
              <div style={{ width: 300 }}>
                <Field
                  name="naturalPersonData.pesel"
                  component={FormTextField}
                  label="Numer PESEL"
                  fullWidth
                />
              </div>
              <ParticipantAddress fieldPrefix="naturalPersonData" />
            </React.Fragment>
            : values.participantType === ParticipantTypes.legalEntity
              ? <React.Fragment>
                <div>
                  <Field
                    name="organizationType"
                    component={FormSelect}
                    label="Typ organizacji"
                    fullWidth
                    values={organizationTypes}
                  />
                </div>
                <div>
                  <Field
                    name="legalEntityData.name"
                    component={FormTextField}
                    label="Nazwa organizacji"
                    fullWidth
                  />
                </div>
                <div style={{ width: 300 }}>
                  <Field
                    name="legalEntityData.taxId"
                    component={FormTextField}
                    label="Numer NIP"
                    fullWidth
                  />
                </div>
                <div style={{ width: 300 }}>
                  <Field
                    name="legalEntityData.regon"
                    component={FormTextField}
                    label="Numer REGON"
                    fullWidth
                  />
                </div>
                <div style={{ width: 300 }}>
                  <Field
                    name="legalEntityData.krs"
                    component={FormTextField}
                    label="Numer KRS"
                    fullWidth
                  />
                </div>
                <ParticipantAddress fieldPrefix="legalEntityData" />
              </React.Fragment>
            : null}
          <Button variant="contained" color="primary" type="submit" disabled={submitting} style={{ marginTop: 20 }}>
            {submitting ? t('auth.userProfile.submitInProgressButton') : t('auth.userProfile.submitButton')}
          </Button>
        </form>
      )}
    />
  );
};

UserProfileForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default translate()(UserProfileForm);



// WEBPACK FOOTER //
// ./src/components/userProfile/UserProfileForm.js